// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".sgf-ace .footer-view__recaptcha__checkbox[data-v-5be2f702]{display:flex;justify-content:space-between;padding:0 0 var(--ace-gutter) var(--ace-gutter);gap:var(--ace-gutter)}.sgf-ace .footer-view__layout[data-v-5be2f702]{display:flex;gap:var(--ace-gutter)}.sgf-ace .footer-view__layout__validation[data-v-5be2f702]{flex:1}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
